import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { House, ScanBarcode, Shield, Split, GraduationCap, Import, ShoppingCart, ShoppingBasket, ShoppingBag, IndianRupee, GlobeLock, AtSign, AlarmClockCheck, ChevronsLeft } from 'lucide-react';
import { getModulePermissions, getPermissions } from "../utils/getPermissions";
import { API_URL } from "../utils/constant";

const CompanySidebar = () => {
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(null);
    const path = location.pathname;
    const companyData = JSON.parse(localStorage.getItem('company'));

    const toggleMenu = (menu) => {
        setOpenMenu((prevMenu) => (prevMenu === menu ? null : menu));
    };


    const toggleMainMenu = () => {
        const appMenu = document.querySelector('.main-wrapper.navbar-menu'); // selects the element with both classes
        if (appMenu) appMenu.style.marginLeft = '';
    };


    const groups = {
        dashboard: ["/dashboard"],
        reports: ["/reports"],
        users: [
            "/roles",
            "/permissions",
            "/branch",
            "/branch/users",
        ],

        master: [
            "/currencies",
            "/locations",
            "/warehouse",
            "/suppliers",
            "/customers",
            "/setup/taxes",
            "/setup/units",
            "/brands",
            "/product-attributes",
        ],

        dispense_master: [
            "/dispensing-master",
            "/dispensing-materials",
        ],

        import: [
            "/import",
            "/import/ideal-stock",
            "/import/stock-remove",
            "/import/purchases",
            "/import/images",
        ],

        purchases: [
            "/setup/categories",
            "/raw-products",
        ],

        finalProducts: [
            "/categories",
            "/products",
        ],

        purchaseSystem: [
            "/payment/supplier",
            "/pushed-purchase",
            "/approved-purchase",
            "/raw-products/stock",
            "/raw-products/purchases",
            "/raw-products-stock",
        ],

        salesSystem: [
            "/reports/sales",
            "/reports/stock",
            "/tenders/sale",
            "/tenders/cost",
            "/tenders/order",
            "/tenders/delivered",
            "/tenders/production",
        ],

        accounts: [
            "/accounts/sales-bills",
            "/accounts/bills",
            "/accounts/credit-notes",
            "/accounts/assets",
        ],

        tasks: [
            "/task/assigned-to-you",
            "/task/assigned-by-you",
        ],
    };

    // Function to check if the current path belongs to a group
    const isActiveGroup = (groupPaths) =>
        groupPaths.some((g) => path.startsWith(g));

    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-logo active">
                <a href="/" className="logo logo-normal">
                    {companyData.company?.company_logo ? (
                        <img src={`${API_URL}${companyData.company?.company_logo}`} alt="Img" />
                    ) : (
                        <img src="/logo.png" alt="Img" />
                    )}
                </a>
                <a href="/" className="logo logo-white">
                    {companyData.company?.company_logo ? (
                        <img src={`${API_URL}${companyData.company?.company_logo}`} alt="Img" />
                    ) : (
                        <img src="/logo.png" alt="Img" />
                    )}
                </a>
                <a href="/" className="logo-small">
                    {companyData.company?.company_logo ? (
                        <img src={`${API_URL}${companyData.company?.company_logo}`} alt="Img" />
                    ) : (
                        <img src="/logo.png" alt="Img" />
                    )}
                </a>
                <Link id="toggle_btn" to={`#0`}>
                    <ChevronsLeft />
                </Link>
            </div>
            <div className="modern-profile p-3 pb-0">
                <div className="text-center rounded bg-light p-3 mb-4 user-profile">
                    <div className="avatar avatar-lg online mb-3">
                        <img
                            src="assets/img/customer/customer15.jpg"
                            alt="Img"
                            className="img-fluid rounded-circle"
                        />
                    </div>
                    <h6 className="fs-14 fw-bold mb-1">Adrian Herman</h6>
                    <p className="fs-12 mb-0">System Admin</p>
                </div>
                <div className="sidebar-nav mb-3">
                    <ul
                        className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
                        role="tablist"
                    >
                        <li className="nav-item">
                            <a className="nav-link active border-0" href="#">
                                Menu
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link border-0" href="chat.html">
                                Chats
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link border-0" href="email.html">
                                Inbox
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="sidebar-header p-3 pb-0 pt-2">
                <div className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
                    <div className="avatar avatar-md onlin">
                        <img
                            src="assets/img/customer/customer15.jpg"
                            alt="Img"
                            className="img-fluid rounded-circle"
                        />
                    </div>
                    <div className="text-start sidebar-profile-info ms-2">
                        <h6 className="fs-14 fw-bold mb-1">Adrian Herman</h6>
                        <p className="fs-12">System Admin</p>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between menu-item mb-3">
                    <div>
                        <a href="index.html" className="btn btn-sm btn-icon bg-light">
                            <i className="ti ti-layout-grid-remove" />
                        </a>
                    </div>
                    <div>
                        <a href="chat.html" className="btn btn-sm btn-icon bg-light">
                            <i className="ti ti-brand-hipchat" />
                        </a>
                    </div>
                    <div>
                        <a
                            href="email.html"
                            className="btn btn-sm btn-icon bg-light position-relative"
                        >
                            <i className="ti ti-message" />
                        </a>
                    </div>
                    <div className="notification-item">
                        <a
                            href="activities.html"
                            className="btn btn-sm btn-icon bg-light position-relative"
                        >
                            <i className="ti ti-bell" />
                            <span className="notification-status-dot" />
                        </a>
                    </div>
                    <div className="me-0">
                        <a
                            href="general-settings.html"
                            className="btn btn-sm btn-icon bg-light"
                        >
                            <i className="ti ti-settings" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul>
                        <li className="submenu-open">
                            <Link to={'/dashboard'} className={`submenu ${isActiveGroup(groups.dashboard) ? "active" : ""}`}>
                                <i className="ti ti-layout-grid fs-16 me-2" />
                                <span>Dashboard</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/reports'} className={`submenu ${isActiveGroup(groups.reports) ? "active" : ""}`}>
                                <i className="ti ti-layout-grid fs-16 me-2" />
                                <span>Reports</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={`/roles`} className={`subdrop ${isActiveGroup(groups.users) ? "active" : ""}`}>
                                <i className="ti ti-shield-up fs-16 me-2"></i>
                                <span>Users Management</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/currencies'} className={`subdrop ${isActiveGroup(groups.master) ? "active" : ""}`}>
                                <i className="ti ti-settings fs-16 me-2"></i>
                                <span>Master Setup</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/dispensing-master'} className={`submenu ${path === "/dispensing-master" ? "active" : ""}`}>
                                <i className="ti ti-database fs-16 me-2" />
                                <span>Dispensing Master</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/dispensing-materials'} className={`submenu ${path === "/dispensing-materials" ? "active" : ""}`}>
                                <i className="ti ti-package fs-16 me-2" />
                                <span>Dispensing Materials</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/import'} className={`subdrop ${isActiveGroup(groups.import) ? "active" : ""}`}>
                                <i className="ti ti-upload fs-16 me-2"></i>
                                <span>Imports Data</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/categories'} className={`subdrop ${isActiveGroup(groups.finalProducts) ? "active" : ""}`}>
                                <i className="ti ti-home-bolt fs-16 me-2"></i>
                                <span>Products / Services</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/payment/supplier'} className={`subdrop ${isActiveGroup(groups.purchaseSystem) ? "active" : ""}`}>
                                <i className="ti ti-chart-pie-2 fs-16 me-2"></i>
                                <span>Purchase System</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/reports/sales'} className={`subdrop ${isActiveGroup(groups.salesSystem) ? "active" : ""}`}>
                                <i className="ti ti-chart-bar fs-16 me-2"></i>
                                <span>Sales System</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/accounts/sales-bills'} className={`subdrop ${isActiveGroup(groups.accounts) ? "active" : ""}`}>
                                <i className="ti ti-businessplan fs-16 me-2"></i>
                                <span>Account Management</span>
                            </Link>
                        </li>

                        <li className="submenu-open">
                            <Link to={'/task/assigned-to-you'} className={`subdrop ${isActiveGroup(groups.tasks) ? "active" : ""}`}>
                                <i className="ti ti-arrows-shuffle fs-16 me-2"></i>
                                <span>Task Management</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CompanySidebar;
